type QueryParamPrimitive = string | number | boolean | null | undefined;
type QueryParamValue = QueryParamPrimitive | QueryParamPrimitive[];

export interface URLParams {
  query?: Record<string, QueryParamValue>;
}

const encodeQueryComponent = (value: string): string =>
  encodeURIComponent(value).replace(
    /[!'()*]/g,
    (char) => `%${char.charCodeAt(0).toString(16).toUpperCase()}`
  );

const stringifyQueryParam = (
  key: string,
  value: QueryParamPrimitive
): string | null => {
  if (value === undefined) {
    return null;
  }

  const encodedKey = encodeQueryComponent(key);
  if (value === null) {
    return encodedKey;
  }

  return `${encodedKey}=${encodeQueryComponent(String(value))}`;
};

export const getNullableQueryParam = (
  field: string,
  inputParam: number | string | null | undefined
) => ({
  ...(inputParam ? { [field]: inputParam } : {}),
});

export const getQueryString = (params: any): string => {
  if (!params) {
    return '';
  }

  const query = Object.keys(params)
    .sort()
    .reduce<string[]>((parts, key) => {
      const value = params[key];
      const values = Array.isArray(value) ? value : [value];
      values.forEach((value) => {
        const queryParam = stringifyQueryParam(key, value);
        if (queryParam !== null) {
          parts.push(queryParam);
        }
      });
      return parts;
    }, [])
    .join('&');

  if (query) {
    return `?${query}`;
  }
  return query;
};

export const getUrl = (path: string, params?: URLParams): string => {
  const apiUrl = API_URL.replace(/\/$/, '');
  path = path.replace(/^\//, '');
  params = params || {};
  if (params?.query) {
    path += getQueryString(params.query);
  }
  return `${apiUrl}/${path}`;
};
